export const getInitialsFromString = (str: string) =>  {
    let initials = str.split(/\s/).reduce((r,word)=> r+=word.slice(0,1),'')
    return initials
  }